import React from "react";
import PropTypes from "prop-types";
import "./style.css";
import { getLinkToProject } from "../../util/pathUtils";

const SingleProject = ({ project, isAdditionalBg, lang, isHorizontal }) => {
  const linkToProject = project.code && getLinkToProject(project.code, lang);

  const getImage = (thumbnailImageUrl) => {
    if (isAdditionalBg) {
      return {
        background: `linear-gradient(0deg, rgba(93, 119, 168, 0.5), rgba(93, 119, 168, 0.5)), url(${thumbnailImageUrl})`,
      }
    }
    return {
      backgroundImage: `url(${thumbnailImageUrl})`,
    };
  }

  return (
    <div style={{
      flexDirection: isHorizontal ? 'row' : 'column',
      justifyContent: isHorizontal ? 'center' : 'space-around',
    }} className="box-shadow border-radius-20 single-project">
      <div
          className="image h-160px img-cover"
          style={{
            ...getImage(project.thumbnailImageUrl),
            ...(isHorizontal ? {
              marginRight: '10px',
              width: '300px',
              height: '100%'
            } : {}),
          }}
          to={linkToProject}
      />

      <div style={{display: "flex", flexDirection: "column"}}>
        <div
            style={isHorizontal ? {width: '400px'} : {}}
            className="project-basket-info p-3">
          <p className="mb-1 locationDescription">{project.locationDescription}</p>
          <p className="name text-color">{project.name}</p>
          <p className="font-sm shortDescription mr-2 text-color">{project.shortDescription}</p>
        </div>

        <div
            style={
              isHorizontal ? {
                paddingBottom: '20px'
              } : {}}
            className="bottom"
        >
          {linkToProject && <a target="_blank" href={linkToProject} className="color-primary font-bold font-sm learn-more">Learn more</a>}
          {project.videoLink &&
              <span className="color-primary font-bold font-sm pt-3">
            <a target="_blank" href={project.videoLink} className="color-primary learn-more">Learn more in this video</a>
          </span>
          }
          {project.link && <a target="_blank" href={project.link} className="color-primary font-bold font-sm learn-more d-block">Press release</a>}
        </div>
      </div>
    </div>
  );
};

SingleProject.propTypes = {
  project: PropTypes.object,
  showLearnMore: PropTypes.bool,
};

export default SingleProject;
